import { useAuthStore } from '@/stores/auth';


export class FeatureFlag {
  can(flag) {
    if (process.env.APP_ENV !== 'production') {
      return true;
    }

    return this.getAuthStore().user?.permissions?.feature_flags[flag];
  }

  getAuthStore() {
    return useAuthStore();
  }
}

export const featureFlagService = new FeatureFlag();
